<template>
  <section class="profile-page">
    <SliderOnBoarding
      v-if="
        (!this.user.jasInfo ||
          user.jasInfo.jasOnboardingDone == null ||
          user.jasInfo.jasOnboardingDone == false) &&
        this.isEditable === false
      "
    />
    <HeroBanner color="gray" :heading="heading" />
    <div class="profile-menu-container">
      <div class="profile-menu-wrapper">
        <div :class="`profile-menu ${activeTab}`">
          <div
            class="profile-menu-link profile-menu-link-progress"
            @click="() => (activeTab = 'progress')"
          >
            Progrès
          </div>
          <div
            class="profile-menu-link profile-menu-link-infos"
            @click="() => (activeTab = 'infos')"
          >
            Infos
          </div>
        </div>
      </div>
    </div>
    <section class="form-container">
      <div
        v-if="activeTab === 'infos' && isEditable === false"
        class="form-wrapper form-wrapper-uneditable"
      >
        <div class="title-and-button">
          <h3>Informations personnelles</h3>
          <a
            @click="
              () => {
                this.isEditable = !this.editable
              }
            "
            >MODIFIER</a
          >
        </div>
        <div class="event-box-container">
          <div v-if="success === true" class="event-success">
            <svg
              width="19"
              height="24"
              viewBox="0 0 19 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5337 5.88295C14.5337 6.04139 14.5974 6.1942 14.7099 6.30669C14.8224 6.41918 14.9753 6.48294 15.1337 6.48294H16.4781C16.8099 6.48294 17.0781 6.21388 17.0781 5.88294C17.0781 5.55107 16.8099 5.28294 16.4781 5.28294H15.1337C14.8028 5.28294 14.5337 5.55107 14.5337 5.88294L14.5337 5.88295Z"
                fill="#68D09E"
              />
              <path
                d="M5.31348 5.88295C5.31348 6.04139 5.3763 6.1942 5.4888 6.30669C5.6013 6.41918 5.75412 6.48294 5.91348 6.48294H7.25786C7.5888 6.48294 7.85786 6.21388 7.85786 5.88294C7.85786 5.55107 7.5888 5.28294 7.25786 5.28294H5.91348C5.5816 5.28294 5.31348 5.55107 5.31348 5.88294L5.31348 5.88295Z"
                fill="#68D09E"
              />
              <path
                d="M11.7962 1.9444V0.600015C11.7962 0.269079 11.5271 1.52588e-05 11.1962 1.52588e-05C10.8643 1.52588e-05 10.5962 0.269079 10.5962 0.600015V1.9444C10.5962 2.27534 10.8643 2.5444 11.1962 2.5444C11.5271 2.5444 11.7962 2.27534 11.7962 1.9444Z"
                fill="#68D09E"
              />
              <path
                d="M14.5152 1.72319L13.5552 2.68319C13.3208 2.91756 13.3208 3.29819 13.5552 3.53257C13.7895 3.76789 14.1702 3.76789 14.4046 3.53257L15.3646 2.57257C15.5989 2.3382 15.5989 1.95757 15.3646 1.72319C15.1302 1.48882 14.7496 1.48882 14.5152 1.72319Z"
                fill="#68D09E"
              />
              <path
                d="M8.41204 3.6984C8.65485 3.6984 8.87423 3.55215 8.96704 3.32808C9.06079 3.10402 9.00923 2.84527 8.83673 2.6737L7.87673 1.7137C7.64235 1.47932 7.26173 1.47932 7.02734 1.7137C6.79297 1.94807 6.79297 2.3287 7.02734 2.56308L7.98734 3.52308C8.09984 3.63558 8.25266 3.69933 8.41202 3.6984L8.41204 3.6984Z"
                fill="#68D09E"
              />
              <path
                d="M1.2 10.6172C0.537192 10.6172 0 11.1553 0 11.8172V22.3201C0 22.6379 0.126562 22.9435 0.351552 23.1685C0.576542 23.3935 0.882168 23.5201 1.2 23.5201H4.6752C5.30614 23.5219 5.83114 23.0335 5.8752 22.4044L6.61958 22.8507C7.32739 23.2754 8.13833 23.5004 8.96426 23.5013H14.0352C14.6484 23.5079 15.2568 23.386 15.8212 23.146C17.4412 22.426 17.6952 21.1613 17.5752 20.3212C18.4274 19.6049 18.7396 18.4321 18.3552 17.3877C18.7565 16.9021 18.9702 16.288 18.9552 15.6571C18.929 15.1639 18.7574 14.6886 18.463 14.2921C18.8408 13.423 18.6196 12.4096 17.9136 11.7769C17.864 11.7309 17.8124 11.6869 17.758 11.6447C17.4843 11.4422 17.1702 11.3025 16.8365 11.2369H16.8102C15.2193 10.8984 14.1486 10.8769 12.5747 10.8769C12.5147 10.5141 12.5175 9.75374 12.9919 8.32135C13.4306 6.99386 13.3931 5.89687 12.8766 5.05975V5.05881C12.4453 4.381 11.7356 3.92913 10.9397 3.826H10.8647C10.2985 3.81569 9.79503 4.18226 9.62909 4.72319C9.62065 4.75132 9.61409 4.78038 9.6094 4.80944L9.4294 6.10506V6.106C9.37596 6.49506 9.26253 6.8738 9.09379 7.22912L7.3444 10.9033C7.07815 11.5183 6.53066 11.9655 5.87534 12.1033V11.8173C5.87534 11.4995 5.74878 11.1939 5.52379 10.9689C5.2988 10.7439 4.99317 10.6173 4.67534 10.6173L1.2 10.6172ZM1.2 22.3201V11.8172H4.6752V22.3201H1.2ZM6 13.3107C7.08094 13.1213 7.99219 12.3985 8.42448 11.3907L10.1598 7.7259C10.3801 7.25997 10.5282 6.7631 10.5985 6.25216L10.7832 5.03997C10.7917 5.03153 10.8029 5.0259 10.8142 5.02309C11.2379 5.09059 11.6129 5.33248 11.8492 5.69058C12.166 6.20432 12.166 6.98432 11.8492 7.94432C11.3832 9.34588 11.2398 10.4521 11.417 11.235V11.234C11.5295 11.7309 11.9729 12.0825 12.4829 12.0787C14.0692 12.0787 15.0488 12.0928 16.5629 12.4125H16.5873H16.5863C16.7467 12.4415 16.8985 12.5053 17.0307 12.6L17.1076 12.6646C17.7217 13.2187 17.3335 13.9293 17.252 14.0615H17.251C17.0926 14.31 17.1376 14.6362 17.357 14.8321C17.5904 15.0684 17.7339 15.3787 17.7629 15.7106C17.7489 16.1568 17.5539 16.5787 17.2229 16.8787C17.0382 17.0746 17.0054 17.3681 17.1432 17.5987C17.1695 17.6446 17.7864 18.7171 16.5648 19.6143V19.6153C16.3548 19.7728 16.2704 20.0474 16.3538 20.2968C16.4185 20.489 16.6726 21.4724 15.3554 22.0509C14.9373 22.2252 14.4882 22.3106 14.0354 22.3012H8.95412C8.34663 22.3003 7.75037 22.1343 7.22912 21.8212L5.87537 21.0093V13.3293L6 13.3107Z"
                fill="#68D09E"
              />
              <path
                d="M3.66901 20.4526C3.66901 21.4285 2.20557 21.4285 2.20557 20.4526C2.20557 19.4767 3.66901 19.4767 3.66901 20.4526Z"
                fill="#68D09E"
              />
            </svg>
            <p>Vos informations ont bien été enregistrées!</p>
          </div>
        </div>
        <!-- Name -->
        <div
          v-if="userInfo.lastname && userInfo.firstname"
          class="profil-lastname"
        >
          <h3>Nom</h3>
          <p>{{ userInfo.lastname + ' ' + userInfo.firstname }}</p>
        </div>
        <!-- Adresse courriel -->
        <div v-if="userInfo.email" class="profil-email">
          <h3>Adresse courriel</h3>
          <p>{{ userInfo.email }}</p>
        </div>
        <!-- Account type -->
        <div v-if="userInfo.jasInfo.type" class="profil-type">
          <h3>Statut</h3>
          <p>{{ userInfo.jasInfo.type }}</p>
        </div>
        <!-- City -->
        <div v-if="userInfo.jasInfo.city" class="profil-city">
          <h3>Ville</h3>
          <p>{{ userInfo.jasInfo.city }}</p>
        </div>
        <!-- Type Precision -->
        <div v-if="userInfo.jasInfo.typeOther" class="profil-type-advanced">
          <h3>École</h3>
          <p>{{ userInfo.jasInfo.typeOther }}</p>
        </div>
        <!-- School -->
        <div v-if="userInfo.jasInfo.school" class="profil-school">
          <h3>École</h3>
          <p>{{ userInfo.jasInfo.school }}</p>
        </div>
        <!-- School Level -->
        <div v-if="userInfo.jasInfo.schoolLevel" class="profil-level">
          <h3>Niveau</h3>
          <p>{{ userInfo.jasInfo.schoolLevel }}</p>
        </div>
        <!-- Team member -->
        <div class="profil-team-member">
          <h3>Fais-tu partie d’une équipe sportive du RSEQ ?</h3>
          <p>{{ userInfo.jasInfo.sport === true ? 'Oui' : 'Non' }}</p>
        </div>
        <!-- Sport -->
        <div v-if="userInfo.jasInfo.sport" class="profil-status">
          <h3>Status</h3>
          <p>{{ userInfo.jasInfo.sport }}</p>
        </div>

        <p class="login-switch">
          <a href="#" @click.prevent="logoutUser">Se déconnecter</a>
        </p>
      </div>
      <form
        v-if="activeTab === 'infos' && isEditable === true"
        class="form-wrapper"
      >
        <!-- Error -->
        <p v-if="!profileComplete" class="form-info">
          Veuillez remplir les informations ci-dessous afin de compléter votre
          profil.
        </p>
        <!-- Error -->
        <div v-if="error" class="form-error">{{ error }}</div>
        <!-- Firstname -->
        <section class="input-container">
          <label for="profile-firstname" class="form-label">Prénom</label>
          <input
            id="profile-firstname"
            v-model="userInfo.firstname"
            type="text"
            class="form-input"
            :class="{ 'has-error': errorInputs.includes('firstname') }"
          />
        </section>
        <!-- Lastname -->
        <section class="input-container">
          <label for="profile-lastname" class="form-label"
            >Nom de famille</label
          >
          <input
            id="profile-lastname"
            v-model="userInfo.lastname"
            type="text"
            class="form-input"
            :class="{ 'has-error': errorInputs.includes('lastname') }"
          />
        </section>
        <!-- Email -->
        <section class="input-container">
          <label for="profile-email" class="form-label">Adresse courriel</label>
          <input
            id="profile-email"
            v-model="userInfo.email"
            type="email"
            class="form-input"
            readonly
          />
        </section>
        <!-- Account type -->
        <section class="input-container">
          <label for="profile-type" class="form-label">Je suis</label>
          <div class="form-select-container">
            <select
              id="profile-type"
              v-model="userInfo.jasInfo.type"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('type') }"
            >
              <option selected disabled>Choisir...</option>
              <option value="student">Élève du secondaire</option>
              <option value="teacher">Intervenant du secondaire</option>
              <option value="other">Autre</option>
            </select>
          </div>
        </section>
        <!-- Type Precision -->
        <section
          v-show="userInfo.jasInfo.type === 'other'"
          class="input-container"
        >
          <label for="profile-type-other" class="form-label">Précisez</label>
          <input
            id="profile-type-other"
            v-model="userInfo.jasInfo.typeOther"
            type="text"
            class="form-input"
            :class="{ 'has-error': errorInputs.includes('typeOther') }"
          />
        </section>
        <!-- City -->
        <section class="input-container">
          <label for="profile-city" class="form-label">Ville</label>
          <div class="form-select-container">
            <select
              id="profile-city"
              v-model="userInfo.jasInfo.city"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('city') }"
            >
              <option selected disabled>Choisir...</option>
              <option v-for="(city, index) in cities" :key="index">
                {{ city }}
              </option>
            </select>
          </div>
        </section>
        <!-- School -->
        <section
          v-show="
            userInfo.jasInfo.type === 'student' ||
            userInfo.jasInfo.type === 'teacher'
          "
          class="input-container"
        >
          <label for="profile-school" class="form-label">École</label>
          <div class="form-select-container">
            <select
              id="profile-school"
              v-model="userInfo.jasInfo.school"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('school') }"
            >
              <option selected disabled>Choisir...</option>
              <option v-for="(school, index) in schools" :key="index">
                {{ school }}
              </option>
            </select>
          </div>
        </section>
        <!-- School Level -->
        <section
          v-show="userInfo.jasInfo.type === 'student'"
          class="input-container"
        >
          <label for="profile-school-level" class="form-label"
            >Quel niveau ?</label
          >
          <div class="form-select-container">
            <select
              id="profile-school-level"
              v-model="userInfo.jasInfo.schoolLevel"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('schoolLevel') }"
            >
              <option selected disabled>Choisir...</option>
              <option>1re secondaire</option>
              <option>2e secondaire</option>
              <option>3e secondaire</option>
              <option>4e secondaire</option>
              <option>5e secondaire</option>
            </select>
          </div>
        </section>
        <!-- Team member -->
        <section
          v-show="userInfo.jasInfo.type === 'student'"
          class="input-container"
        >
          <label for="profile-teamMember" class="form-label"
            >Fais-tu partie d’une équipe sportive du RSEQ ?</label
          >
          <div class="form-select-container">
            <select
              id="profile-teamMember"
              v-model="userInfo.jasInfo.teamMember"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('teamMember') }"
            >
              <option :value="false">Non</option>
              <option :value="true">Oui</option>
            </select>
          </div>
        </section>
        <!-- Sport -->
        <section
          v-show="
            userInfo.jasInfo.type === 'student' && userInfo.jasInfo.teamMember
          "
          class="input-container"
        >
          <label for="profile-sport" class="form-label"
            >De quelle discipline ?
          </label>
          <div class="form-select-container">
            <select
              id="profile-sport"
              v-model="userInfo.jasInfo.sport"
              class="form-select"
              :class="{ 'has-error': errorInputs.includes('sport') }"
            >
              <option v-for="(sport, index) in sports" :key="index">
                {{ sport }}
              </option>
            </select>
          </div>
        </section>
        <!-- Newsletter -->
        <section v-if="isEditable" class="form-checkbox-container">
          <input
            id="register-consent"
            v-model="userInfo.jasInfo.newsletter"
            type="checkbox"
            class="form-checkbox"
          />
          <label for="register-consent" class="checkbox-label">
            J’accepte de recevoir des courriels d’information de la part de
            l’équipe Jeune actif au secondaire
          </label>
        </section>
        <!-- Button -->
        <button
          v-if="isEditable"
          class="form-button"
          @click.prevent="validateForm"
        >
          {{ submitCta }}
        </button>
      </form>
      <div v-if="activeTab === 'progress'" class="progress-container">
        <h3>
          Mes points
          <p class="counter-score-container">
            <span class="counter-score">{{
              this.userInfo.jasInfo.challenges.length
            }}</span>
            points
          </p>
        </h3>
        <!-- <button @click="togglePopupInvite" class="button-invite-friend"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3189_5216)"><path d="M7.21813 8.59971C9.52175 8.59971 11.3894 6.67441 11.3894 4.29966C11.3894 1.92492 9.52175 0 7.21813 0C4.91451 0 3.04688 1.92492 3.04688 4.30004C3.04688 6.67517 4.91451 8.60009 7.21813 8.60009V8.59971ZM7.21813 1.19689C8.87792 1.19689 10.228 2.58901 10.228 4.29966C10.228 6.01032 8.87755 7.40244 7.21813 7.40244C5.55871 7.40244 4.20828 6.01032 4.20828 4.29966C4.20828 2.58901 5.55834 1.19689 7.21813 1.19689Z" fill="white"/><path d="M10.6664 9.10663H10.4054C9.49875 9.74674 8.40047 10.1224 7.21802 10.1227C6.03556 10.1227 4.93728 9.74713 4.0306 9.10663H3.7696C2.73001 9.10663 1.78383 9.54352 1.10382 10.2445C0.423807 10.9509 0 11.9206 0 12.9926C0 15.8914 3.59535 17 7.04155 17C7.10025 17 7.15858 17 7.21728 16.9989H7.21875C7.27745 16.9996 7.33578 17 7.39448 17C10.8407 17 14.436 15.8914 14.436 12.9926C14.436 11.9206 14.0122 10.9505 13.3322 10.2445C12.6522 9.54352 11.706 9.10663 10.6664 9.10663ZM7.39448 15.8031C7.33984 15.8031 7.28557 15.8031 7.23094 15.8024C7.22688 15.8024 7.22134 15.8024 7.21728 15.8024C7.21322 15.8024 7.20916 15.8024 7.20509 15.8024C7.15046 15.8031 7.09619 15.8031 7.04155 15.8031C4.85754 15.8031 1.16104 15.2113 1.16104 12.9926C1.16104 12.2775 1.43349 11.6013 1.92485 11.0909C2.39887 10.6023 3.0235 10.3248 3.69133 10.3047C4.75344 10.9695 5.96505 11.3193 7.21838 11.3193C8.47135 11.3193 9.68297 10.9691 10.7451 10.3047C11.4125 10.3248 12.0372 10.6019 12.5082 11.0879C13.0025 11.6013 13.275 12.2779 13.275 12.9926C13.275 15.2113 9.57849 15.8031 7.39448 15.8031Z" fill="white"/><path d="M17.4189 5.89806H15.8688V4.30005C15.8688 3.96972 15.6089 3.70142 15.2881 3.70142C14.9673 3.70142 14.7074 3.96934 14.7074 4.30005V5.89806H13.1569C12.8364 5.89806 12.5762 6.16598 12.5762 6.49669C12.5762 6.82741 12.8361 7.09533 13.1569 7.09533H14.7074V8.69371C14.7074 9.02405 14.9673 9.29235 15.2881 9.29235C15.6089 9.29235 15.8688 9.02443 15.8688 8.69371V7.09533H17.4189C17.7394 7.09533 17.9997 6.82741 17.9997 6.49669C17.9997 6.16598 17.7398 5.89806 17.4189 5.89806Z" fill="white"/></g><defs><clipPath id="clip0_3189_5216"><rect width="18" height="17" fill="white"/></clipPath></defs></svg>Inviter un ami</button> -->
        <h3>Avancement</h3>
        <ProgressBar v-if="physicalActivity" :infos="physicalActivity" />
        <ProgressBar
          v-for="(progressBar, index) in allSports"
          :key="`sports-${index}`"
          :infos="progressBar"
        />
        <PopupInviteFriend
          v-if="popupInviteFriend === true"
          @closePopup="togglePopupInvite"
        />
      </div>
    </section>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNil } from 'lodash'
import axios from 'axios'
// eslint-disable-next-line import/extensions
import { backOnError, validateEmail, isProfileComplete } from '@/misc/helpers'
import json from '@/assets/schools_list.json'
// eslint-disable-next-line import/extensions
import HeroBanner from '@/components/HeroBanner'
import ProgressBar from '@/components/ProgressBar.vue'
import SliderOnBoarding from '@/components/SliderOnBoarding.vue'
import PopupInviteFriend from '@/components/PopupInviteFriend.vue'

export default {
  components: { HeroBanner, ProgressBar, SliderOnBoarding, PopupInviteFriend },
  data() {
    return {
      heading: 'Mon profil',
      submitCta: 'Enregistrer',
      error: '',
      errorInputs: [],
      schoolsList: json.schools,
      userInfo: {
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        jasInfo: {
          type: '',
          typeOther: '',
          city: '',
          school: '',
          schoolLevel: '',
          teamMember: false,
          sport: '',
          newsletter: false,
          challenges: [],
        },
      },
      activeTab: 'progress',
      isEditable: false,
      allSports: [],
      physicalActivity: null,
      success: false,
      popupInviteFriend: false,
    }
  },
  computed: {
    profileComplete() {
      return isProfileComplete(this.user)
    },
    cities() {
      const cities = []

      this.schoolsList.forEach((school) => {
        const { city } = school

        if (!cities.includes(city)) {
          cities.push(city)
        }
      })

      cities.sort()

      return cities
    },
    schools() {
      let filteredSchools = this.schoolsList

      if (this.userInfo.jasInfo.city && this.userInfo.jasInfo.city.length) {
        filteredSchools = filteredSchools.filter(
          (el) => el.city === this.userInfo.jasInfo.city
        )
      }

      return filteredSchools.map((el) => el.schoolName)
    },
    sports() {
      const sportsList = [
        'Athlétisme',
        'Autre',
        'Badminton',
        'Ballon sur glace',
        'Baseball',
        'Basketball',
        'Cheerleading',
        'Course sur route',
        'Crosscountry',
        'Crosse au champ',
        'Curling',
        'Deck hockey',
        'Flag rugby',
        'Flag-football',
        'Football',
        'Futsal',
        'Golf',
        'Gymnastique',
        'Haltérophilie',
        'Handball',
        'Hockey',
        'Hockey&nbsp;Cosom',
        'Kin-ball',
        'Lutte',
        'Natation',
        'Rugby',
        'Ski alpin',
        'Ski de fond',
        'Soccer',
        'Softball',
        'Tchoukball',
        'Tennis',
        'Tennis de table',
        'Touch football',
        'Ultimate',
        'Volleyball',
      ]

      return sportsList
    },
    ...mapState('authentication', ['user']),
    ...mapState('app', [
      'appTitle',
      'seoDescription',
      'seoImage',
      'apiUrl',
      'bearer',
    ]),
  },
  async mounted() {
    if (
      this.user.jasInfo === undefined ||
      this.user.jasInfo.jasOnboardingDone === null ||
      this.user.jasInfo.jasOnboardingDone === false ||
      !isProfileComplete(this.user)
    ) {
      this.activeTab = 'infos'
      this.isEditable = true
    }
    if (!isNil(this.$route.query.redirectUrl)) {
      this.$router.push(this.$route.query.redirectUrl)
    }

    this.userInfo.id = this.user.id
    this.userInfo.firstname = this.user.firstname
    this.userInfo.lastname = this.user.lastname
    this.userInfo.email = this.user.email

    if (this.user.jasInfo) {
      this.userInfo.jasInfo.type = this.user.jasInfo.type
      this.userInfo.jasInfo.typeOther = this.user.jasInfo.typeOther
      this.userInfo.jasInfo.city = this.user.jasInfo.city
      this.userInfo.jasInfo.school = this.user.jasInfo.school
      this.userInfo.jasInfo.schoolLevel = this.user.jasInfo.schoolLevel
      this.userInfo.jasInfo.teamMember = this.user.jasInfo.teamMember
      this.userInfo.jasInfo.sport = this.user.jasInfo.sport
      this.userInfo.jasInfo.newsletter = this.user.jasInfo.newsletter
      this.userInfo.jasInfo.challenges = this.user.jasInfo.challenges
    }
    const query = `query MyQuery {
      categories(group: "sports", level: 1) {
        title
        id
        slug
      }
      entries(section: "physicalActivity") {
        id
      }
    }`

    try {
      const result = await axios({
        method: 'POST',
        url: this.apiUrl,
        data: {
          query,
        },
        headers: {
          Authorization: `Bearer ${this.bearer}`,
        },
      })

      const { entries, categories } = result.data.data

      this.physicalActivity = {
        name: 'Activité Physique',
        idsChallenges: entries.map((el) => el.id),
        color: 'red',
        type: 'physical-activity',
      }

      const sportCategories = categories.filter(
        (el) => el.slug !== 'activite-physique'
      )
      if (sportCategories.length) {
        this.allSports = sportCategories.map((el) => {
          return {
            id: el.id,
            name: el.title,
            color: 'purple',
            idsChallenges: [],
            type: 'sport',
          }
        })
      }
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    togglePopupInvite() {
      this.popupInviteFriend = !this.popupInviteFriend
    },
    eventSuccess() {
      this.success = true
      setTimeout(() => {
        this.success = false
      }, 2000)
    },
    validateForm() {
      this.error = ''
      this.errorInputs = []
      let validation = true

      // Check if fields are filled
      if (!this.userInfo.firstname.length) {
        validation = false
        this.errorInputs.push('firstname')
      }
      if (!this.userInfo.lastname.length) {
        validation = false
        this.errorInputs.push('lastname')
      }
      if (!this.userInfo.email.length) {
        validation = false
        this.errorInputs.push('email')
      }
      if (!this.userInfo.jasInfo.city.length) {
        validation = false
        this.errorInputs.push('city')
      }
      if (!this.userInfo.jasInfo.type.length) {
        validation = false
        this.errorInputs.push('type')
      }
      if (
        this.userInfo.jasInfo.type === 'other' &&
        !this.userInfo.jasInfo.typeOther
      ) {
        validation = false
        this.errorInputs.push('typeOther')
      }
      if (this.userInfo.jasInfo.type === 'teacher') {
        if (!this.userInfo.jasInfo.school.length) {
          validation = false
          this.errorInputs.push('school')
        }
      }
      if (this.userInfo.jasInfo.type === 'student') {
        if (!this.userInfo.jasInfo.school.length) {
          validation = false
          this.errorInputs.push('school')
        }
        if (!this.userInfo.jasInfo.schoolLevel.length) {
          validation = false
          this.errorInputs.push('schoolLevel')
        }
        if (
          this.userInfo.jasInfo.teamMember &&
          !this.userInfo.jasInfo.sport.length
        ) {
          validation = false
          this.errorInputs.push('sport')
        }
      }
      if (!validation) {
        this.error = 'Veuillez remplir tous les champs.'
        backOnError()
        return false
      }

      // Check email format
      if (!validateEmail(this.userInfo.email)) {
        this.errorInputs.push('email')
        this.error = 'Veuillez rentrer un format de courriel correct.'
        backOnError()
        return false
      }

      if (this.userInfo.jasInfo.type !== 'other') {
        this.userInfo.jasInfo.typeOther = ''
      }

      if (this.userInfo.jasInfo.type === 'other') {
        this.userInfo.jasInfo.school = ''
        this.userInfo.jasInfo.schoolLevel = ''
      }

      if (this.userInfo.jasInfo.type === 'teacher') {
        this.userInfo.jasInfo.schoolLevel = ''
      }

      this.submit()
      this.eventSuccess()
      return true
    },
    logoutUser() {
      this.logout()

      this.$router.push('/')
    },
    async submit() {
      this.submitCta = '...'
      await this.updateUser(this.userInfo)

      this.submitCta = "C'est fait !"

      setTimeout(() => {
        this.submitCta = 'Enregistrer'
        this.isEditable = false
      }, 3000)
    },
    ...mapActions('authentication', ['logout', 'updateUser']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/theme/app.scss';

.profile-page {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form-container {
    .form-wrapper-uneditable {
      align-items: flex-start;
      .title-and-button {
        display: flex;
        justify-content: space-between;
        width: 100%;
        h3,
        a {
          margin: 5px 0;
          font-weight: 700;
          font-size: 16px;
        }

        a {
          margin: 8px 0;
          color: $purple;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
        }
      }
      .event-box-container {
        width: 100%;
        height: 40px;
        .event-success {
          display: flex;
          flex-direction: row;
          height: 100%;
          width: 100%;
          padding: 7px 16px;
          align-items: center;
          border-radius: 4px;
          background-color: $lightGray;
          svg {
            margin-right: 12px;
          }
        }
      }

      .login-switch {
        text-align: center;
        width: 100%;
      }

      h3 {
        font-weight: 700;
        font-size: 12px;
        margin: 20px 0 5px;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        margin: 5px 0;
      }
    }
  }

  .profile-menu-container {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    background-color: $light;

    .profile-menu-wrapper {
      width: 100%;
      max-width: 400px;
      display: flex;
      flex-direction: column;

      .profile-menu {
        position: relative;
        display: flex;
        height: 100%;
        flex-direction: row;
        border-bottom: 1px solid #edeff7;

        &::after {
          content: '';
          position: absolute;
          width: 50%;
          height: 4px;
          background-color: #ff612f;
          bottom: -1px;
          transition: all 0.5s ease;
        }
        &.infos {
          &::after {
            left: 50%;
          }
          .profile-menu-link-infos {
            color: #ff612f;
          }
          .profile-menu-link-progress:hover {
            color: #ff612f;
            cursor: pointer;
          }
        }

        &.progress {
          &::after {
            left: 0;
          }
          .profile-menu-link-progress {
            color: #ff612f;
          }
          .profile-menu-link-infos:hover {
            color: #ff612f;
            cursor: pointer;
          }
        }

        .profile-menu-link {
          display: flex;
          height: 100%;
          width: 50%;
          align-items: center;
          font-size: 20px;
          justify-content: center;
          font-weight: 500;
          cursor: pointer;
          color: #89969f;
        }
      }
    }
  }
  .progress-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;

    h3 {
      display: flex;
      font-weight: 700;
      font-size: 16px;
      margin: 0;
      flex-wrap: nowrap;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 30px;
      .counter-score-container {
        margin: 0;
        .counter-score {
          font-weight: 500;
          font-size: 32px;
        }
      }
    }

    .button-invite-friend {
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 8px;
      background-color: $purple;
      font-size: 18px;
      font-family: $fontFurura;
      font-weight: 500;
      color: white;
      cursor: pointer;
      margin-bottom: 30px;
      svg {
        margin-right: 10px;
      }
    }
  }
}
</style>
